import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const PuppyCard = ({ puppy, index = 0 }) => {
  const adopted = puppy.status === "adopted";
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`puppy-card-${puppy.id}`}
      className="group"
    >
      <Link to={adopted ? "/adopted" : `/puppy/${puppy.id}`} className="block">
        <div className="relative overflow-hidden rounded-md bg-[#F5E6E3] aspect-[4/5]">
          <img
            src={puppy.images?.[0]}
            alt={puppy.name}
            className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
          />
          {adopted && (
            <>
              <div className="absolute inset-0 bg-[#2A2118]/25" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="adopted-stamp px-8 py-3 text-3xl md:text-4xl font-medium">
                  ADOPTED
                </span>
              </div>
            </>
          )}
          {!adopted && (
            <span className="absolute top-4 left-4 label-eyebrow bg-white/80 backdrop-blur-md text-[#2A2118] px-3 py-1.5 rounded-sm">
              Available
            </span>
          )}
        </div>
        <div className="mt-4 flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading text-2xl font-medium leading-tight text-[#2A2118]">
              {puppy.name}
            </h3>
            <p className="text-sm text-[#8a7a68] mt-0.5">{puppy.breed}</p>
          </div>
          {!adopted && (
            <p className="font-heading text-xl text-[#2A2118] whitespace-nowrap">
              ${puppy.price?.toLocaleString()}
            </p>
          )}
        </div>
      </Link>
    </motion.div>
  );
};
